import React from 'react'
import PropTypes from 'prop-types'
import styled, { injectGlobal } from 'styled-components'
import { ThemeConsumer } from 'contexts/theme-context'
import { ConfigConsumer } from 'contexts/config-context'
import { media } from 'tools/browser'
import SubNav from 'molecules/SubNav'

injectGlobal`
  #universal-header {
    position: relative;
    z-index: 150;
    height: 48px;

    &.show-subnav-bar {
      height: 92px;
    }

    @media (min-width: 1000px) {
      height: 145px;
      
      &.show-subnav-bar {
        height: 189px;
      }
    }
  }

  body.shgn-scroll-lock {
    overflow: hidden;
  }
`

const Wrapper = styled.div`
    background-color: rgba(56, 64, 71, 1);
    height: 48px;
    z-index: 1;
    text-align: left;

    ${media.greaterThan.large`
        position: relative;
        height: 145px;
    `}
  
    a {
        text-decoration: none;
        transition: .2s opacity ease-in-out;
    }

    ul {
        list-style-type: none;
    }
`

const NavBackground = styled.div`
    background-color: ${props => props.bgColor};
    transform: skew(-45deg);
    position: absolute;
    left: -10%;
    top: 0;
    height: 48px;
    width: 72%;
    border-right: 10px solid #FFF;

    @media (min-width: ${props => props.contentWidth}) {
        width: calc(((100% - ${props => props.contentWidth}) / 2)  + (${props => props.contentWidth} * .75 + 10%));
    }

    @media (min-width: 1000px) {
      height: 145px;
    }
`

const NavWrapper = styled.div`
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;

    ${media.greaterThan.large`
        display: block;
        height: auto;
    `}
`

function NavBar (props) {
  return (

    <ThemeConsumer>
      {theme => (
        <ConfigConsumer>
          {config => (
            <React.Fragment>
              <Wrapper>
                <NavBackground bgColor={theme.color} contentWidth={config.contentMaxWidth || '1280px'}/>
                <NavWrapper>
                  {props.children}
                </NavWrapper>
              </Wrapper>
              <SubNav config={config} />
            </React.Fragment>
          )}
        </ConfigConsumer>
      )}
    </ThemeConsumer>

  )
}

NavBar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default NavBar



// WEBPACK FOOTER //
// ./src/templates/NavBar.js